<template>
  <v-app>
  <router-view></router-view>
  
    <v-bottom-nav app :value="true"  color="white">
      <v-btn flat color="orange darken-4" value="Message" @click.native="dialog = true">
        <span>Message</span>
        <v-badge right>
          <span slot="badge">0</span>
          <v-icon medium>fa-commenting-o</v-icon>
        </v-badge>
      </v-btn>
      <v-btn flat color="orange darken-4" value="Accueil" router :to="'/accueil'">
        <span>Accueil</span>
        <v-icon medium>fa-home</v-icon>
      </v-btn>
      <v-btn flat color="orange darken-4" value="Notifications" @click.native="dialog = true">
        <span>Notifications</span>
        <v-badge right>
          <span slot="badge">0</span>
          <v-icon medium>fa-bell-o</v-icon>
        </v-badge>
      </v-btn>
      <v-btn flat color="orange darken-4" value="Mon compte" router :to="'/compte'">
        <span>Mon compte</span>
        <v-icon medium>fa-user</v-icon>
      </v-btn>
    </v-bottom-nav>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Version BETA</v-card-title>
        <v-card-text>Cette fonction n'est pas encore disponible dans cette version</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click.native="dialog = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false
      }
    }
  }
</script>

<style>
.app-main-toolbar {
  border-bottom: #F4F5F7 2px solid !important;
  z-index: 5;
}

.navigation-drawer {
  z-index: 6;
}

.navigation-drawer .toolbar {
  background: #FFF !important;
  border-bottom: #F4F5F7 2px solid;
}

.navigation-drawer nav.toolbar {
  background: inherit;
}

.navigation-drawer__border {
  display: none;
}

.tab {
  width: 100%;
}
.round-menu-icon {
  border-radius: 60px;
  border-color: none;
  box-shadow: 0px 0px 2px;
  padding: 7px;
  font-size: 16px;
  color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Layouts/MainLayout.vue